import { useCallback, useContext, useEffect, useState } from "react"
import { UserContext } from "../../../../context/userContext.js"

//primereact
import { Button } from "primereact/button"

//helpers
import { LogError } from "../../../../helpers/logger.js"
import { LoaderMedium } from "../../../../components/Loaders/index.js"

//styles
import styles from "../../../../styles/kiosk/KioskActivityCheckInOptions.module.css"

import ActivityCheckInDataTable from "./ActivityCheckInDataTable.js"
import ActivityCheckInOptionModal from "./ActivityCheckInOptionModal.js"
import {
  kioskApiGetActivityCheckInOptions,
  kioskApiGetActivityCheckInModalHelpers,
} from "../../kioskApi.js"
import InactiveKioskLabel from "../InactiveKioskLabel.js"

export default function ActivityCheckInOptions({ kiosk_organization_id }) {
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingHelpers, setIsLoadingHelpers] = useState(true)

  const [showModal, setShowModal] = useState(false)
  const [updateList, setUpdateList] = useState(true)
  const [activityCheckInOptions, setActivityCheckInOptions] = useState([])

  const [editOption, setEditOption] = useState(null)
  const [deleteOption, setDeleteOption] = useState(false)

  const [criteria, setCriteria] = useState([])
  const [parentOptions, setParentOptions] = useState([])
  const [successMessages, setSuccessMessages] = useState([])
  const [failureMessages, setFailureMessages] = useState([])

  const userCtx = useContext(UserContext)

  const getActivityCheckInOptions = useCallback(async () => {
    if (updateList) {
      try {
        setIsLoading(true)
        const response = await kioskApiGetActivityCheckInOptions(
          userCtx.tokenKiosk,
          kiosk_organization_id
        )
        if (response) {
          setActivityCheckInOptions(response)
          setUpdateList(false)
          setIsLoading(false)
        } else {
          userCtx.setNotificationError("Activity Check In not found")
        }
      } catch (error) {
        LogError("Unable to load activity check in options", error)
        setIsLoading(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kiosk_organization_id, updateList])

  const getHelpers = useCallback(async () => {
    try {
      setIsLoadingHelpers(true)
      const result = await kioskApiGetActivityCheckInModalHelpers(
        userCtx.tokenKiosk,
        { OrganizationId: kiosk_organization_id }
      )
      setCriteria(
        result.listCriteria?.map((c) => {
          return { id: c.id, description: c.description }
        })
      )
      setParentOptions(result.parentOptions)
      setSuccessMessages(result.successMessages)
      setFailureMessages(result.failureMessages)
      setIsLoadingHelpers(false)
    } catch (error) {
      setCriteria([])
      setParentOptions([])
      setIsLoadingHelpers(false)
      LogError("Unable to get Activity Check In option values", error)
      userCtx.setNotificationError(
        "Unable to get Activity Check In option values"
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kiosk_organization_id, updateList])

  useEffect(() => {
    getActivityCheckInOptions()
    getHelpers()
  }, [getActivityCheckInOptions, getHelpers])

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Button
          label="Add Option"
          className={styles.addOptionsButton}
          onClick={() => {
            setShowModal(true)
          }}
          disabled={isLoading || isLoadingHelpers || !kiosk_organization_id}
        />
      </div>
      {isLoading || isLoadingHelpers ? (
        <LoaderMedium />
      ) : !kiosk_organization_id ? (
        <InactiveKioskLabel />
      ) : !activityCheckInOptions || activityCheckInOptions.length === 0 ? (
        <div className={styles.notFoundMessage}>
          Activity Check In Options not found
        </div>
      ) : (
        <div className={styles.content}>
          <ActivityCheckInDataTable
            activityCheckInOptions={activityCheckInOptions}
            setEditOption={setEditOption}
            setShowModal={setShowModal}
            deleteOption={deleteOption}
            setDeleteOption={setDeleteOption}
          />
        </div>
      )}
      {showModal && (
        <ActivityCheckInOptionModal
          kiosk_organization_id={kiosk_organization_id}
          parentOptions={parentOptions}
          criteria={criteria}
          successMessages={successMessages}
          failureMessages={failureMessages}
          setUpdateList={setUpdateList}
          setEditOption={setEditOption}
          editOption={editOption}
          deleteOption={deleteOption}
          setDeleteOption={setDeleteOption}
          onSave={() => {
            setShowModal(false)
            setEditOption(null)
            setDeleteOption(false)
            setUpdateList(true)
          }}
          onCancel={() => {
            setShowModal(false)
            setEditOption(null)
            setDeleteOption(false)
          }}
        />
      )}
    </div>
  )
}
